{
  "labels": {
    "paste": "Indsæt",
    "pasteAsPlaintext": "Indsæt som klartekst",
    "pasteCharts": "Indsæt diagrammer",
    "selectAll": "Marker alle",
    "multiSelect": "Tilføj element til markering",
    "moveCanvas": "Flyt lærred",
    "cut": "Klip",
    "copy": "Kopier",
    "copyAsPng": "Kopier til klippebord som PNG",
    "copyAsSvg": "Kopier til klippebord som SVG",
    "copyText": "Kopiér til udklipsholder som tekst",
    "copySource": "Kopiér kilde til udklipsholder",
    "convertToCode": "Konvertér til kode",
    "bringForward": "Flyt fremad",
    "sendToBack": "Placer bagest",
    "bringToFront": "Placer forrest",
    "sendBackward": "Send bagud",
    "delete": "Fjern",
    "copyStyles": "Kopier stil",
    "pasteStyles": "Indsæt stil",
    "stroke": "Linje",
    "background": "Baggrund",
    "fill": "Udfyld",
    "strokeWidth": "Linjebredde",
    "strokeStyle": "Linjeform",
    "strokeStyle_solid": "Solid",
    "strokeStyle_dashed": "Stiplet",
    "strokeStyle_dotted": "Prikket",
    "sloppiness": "Sjuskethed",
    "opacity": "Gennemsigtighed",
    "textAlign": "Tekstjustering",
    "edges": "Kanter",
    "sharp": "Skarp",
    "round": "Rund",
    "arrowheads": "Pilehoveder",
    "arrowhead_none": "Ingen",
    "arrowhead_arrow": "Pil",
    "arrowhead_bar": "Bjælke",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trekant",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Skriftstørrelse",
    "fontFamily": "Skrifttypefamilie",
    "addWatermark": "Tilføj \"Lavet med Excalidraw\"",
    "handDrawn": "Hånd-tegnet",
    "normal": "Normal",
    "code": "Kode",
    "small": "Lille",
    "medium": "Mellem",
    "large": "Stor",
    "veryLarge": "Meget stor",
    "solid": "Solid",
    "hachure": "Skravering",
    "zigzag": "Zigzag",
    "crossHatch": "Krydsskravering",
    "thin": "Tynd",
    "bold": "Fed",
    "left": "Venstre",
    "center": "Centrere",
    "right": "Højre",
    "extraBold": "Extra fed",
    "architect": "Arkitekt",
    "artist": "Kunstner",
    "cartoonist": "Tegneserietegner",
    "fileTitle": "Filnavn",
    "colorPicker": "Farvevælger",
    "canvasColors": "Brugt på lærred",
    "canvasBackground": "Lærredsbaggrund",
    "drawingCanvas": "Tegnelærred",
    "layers": "Lag",
    "actions": "Handlinger",
    "language": "Sprog",
    "liveCollaboration": "Live samarbejde...",
    "duplicateSelection": "Duplikér",
    "untitled": "Unavngivet",
    "name": "Navn",
    "yourName": "Dit navn",
    "madeWithExcalidraw": "Fremstillet med Excalidraw",
    "group": "Grupper valgte",
    "ungroup": "Opløs gruppe",
    "collaborators": "Deltagere",
    "showGrid": "Vis gitter",
    "addToLibrary": "Føj til Bibliotek",
    "removeFromLibrary": "Fjern fra biblioteket",
    "libraryLoadingMessage": "Indlæser bibliotek…",
    "libraries": "Gennemse biblioteker",
    "loadingScene": "Indlæser scene…",
    "align": "Justér",
    "alignTop": "Juster til top",
    "alignBottom": "Juster til bund",
    "alignLeft": "Venstrejusteret",
    "alignRight": "Juster højre",
    "centerVertically": "Center vertikalt",
    "centerHorizontally": "Vandret centreret",
    "distributeHorizontally": "Distribuer vandret",
    "distributeVertically": "Distribuer lodret",
    "flipHorizontal": "Spejlvend horisontalt",
    "flipVertical": "Vend lodret",
    "viewMode": "Visningstilstand",
    "share": "Del",
    "showStroke": "Vis stregfarve-vælger",
    "showBackground": "Vis baggrundsfarve-vælger",
    "toggleTheme": "Skift tema",
    "personalLib": "Personligt bibliotek",
    "excalidrawLib": "Excalidraw Bibliotek",
    "decreaseFontSize": "Gør skriften mindre",
    "increaseFontSize": "Gør skriften større",
    "unbindText": "Frigør tekst",
    "bindText": "Bind tekst til beholderen",
    "createContainerFromText": "Ombryd tekst i en beholder",
    "link": {
      "edit": "Redigér link",
      "editEmbed": "Redigér link & indlejret",
      "create": "Link oprettet",
      "createEmbed": "Opret link & indlejret",
      "label": "Links",
      "labelEmbed": "Link & indlejret",
      "empty": "Intet link angivet"
    },
    "lineEditor": {
      "edit": "Rediger Linje",
      "exit": "Afslut linjeeditor"
    },
    "elementLock": {
      "lock": "Lås",
      "unlock": "Lås op",
      "lockAll": "Lås alle",
      "unlockAll": "Lås alle op"
    },
    "statusPublished": "Udgiver",
    "sidebarLock": "Hold sidepanel åben",
    "selectAllElementsInFrame": "Vælg alle elementer i rammen",
    "removeAllElementsFromFrame": "Fjern alle elementer fra ramme",
    "eyeDropper": "Vælg farve fra lærred",
    "textToDiagram": "Tekst til diagram",
    "prompt": "Prompt"
  },
  "library": {
    "noItems": "Ingen varer tilføjet endnu...",
    "hint_emptyLibrary": "Vælg et element på lærred for at tilføje det her, eller installer et bibliotek fra det offentlige arkiv, nedenfor.",
    "hint_emptyPrivateLibrary": "Vælg et element på lærred for at tilføje det her."
  },
  "buttons": {
    "clearReset": "Nulstil lærredet",
    "exportJSON": "Eksportér til fil",
    "exportImage": "Eksporter billede...",
    "export": "Gem til...",
    "copyToClipboard": "Kopier til klippebord",
    "save": "Gem til nuværende fil",
    "saveAs": "Gem som",
    "load": "Åbn",
    "getShareableLink": "Lav et delbart link",
    "close": "Luk",
    "selectLanguage": "Vælg sprog",
    "scrollBackToContent": "Scroll tilbage til indhold",
    "zoomIn": "Zoom ind",
    "zoomOut": "Zoom ud",
    "resetZoom": "Nulstil zoom",
    "menu": "Menu",
    "done": "Færdig",
    "edit": "Rediger",
    "undo": "Fortryd",
    "redo": "Gendan",
    "resetLibrary": "Nulstil bibliotek",
    "createNewRoom": "Opret nyt rum",
    "fullScreen": "Fuld skærm",
    "darkMode": "Mørk tilstand",
    "lightMode": "Lys baggrund",
    "zenMode": "Zentilstand",
    "objectsSnapMode": "Fastgør til objekter",
    "exitZenMode": "Stop zentilstand",
    "cancel": "Annuller",
    "clear": "Ryd",
    "remove": "Fjern",
    "embed": "Slå indlejring til/fra",
    "publishLibrary": "Publicér",
    "submit": "Gem",
    "confirm": "Bekræft",
    "embeddableInteractionButton": "Klik for at interagere"
  },
  "alerts": {
    "clearReset": "Dette vil rydde hele lærredet. Er du sikker?",
    "couldNotCreateShareableLink": "Kunne ikke oprette delbart link.",
    "couldNotCreateShareableLinkTooBig": "Kunne ikke oprette delbart link: scenen er for stor",
    "couldNotLoadInvalidFile": "Kunne ikke indlæse ugyldig fil",
    "importBackendFailed": "Import fra backend mislykkedes.",
    "cannotExportEmptyCanvas": "Kan ikke eksportere tomt lærred.",
    "couldNotCopyToClipboard": "Kunne ikke kopiere til udklipsholderen.",
    "decryptFailed": "Kunne ikke dekryptere data.",
    "uploadedSecurly": "Upload er blevet sikret med ende-til-ende kryptering, hvilket betyder, at Excalidraw server og tredjeparter ikke kan læse indholdet.",
    "loadSceneOverridePrompt": "Indlæsning af ekstern tegning erstatter dit eksisterende indhold. Ønsker du at fortsætte?",
    "collabStopOverridePrompt": "Stopper sessionen vil overskrive din tidligere, lokalt gemte tegning. Er du sikker?\n\n(Hvis du ønsker at beholde din lokale tegning, skal du blot lukke browserfanen i stedet.)",
    "errorAddingToLibrary": "Kunne ikke tilføje element til biblioteket",
    "errorRemovingFromLibrary": "Kunne ikke fjerne element fra biblioteket",
    "confirmAddLibrary": "Dette vil tilføje {{numShapes}} form(er) til dit bibliotek. Er du sikker?",
    "imageDoesNotContainScene": "Dette billede synes ikke at indeholde scene data. Har du aktiveret scene indlejring under eksport?",
    "cannotRestoreFromImage": "Scene kunne ikke gendannes fra denne billedfil",
    "invalidSceneUrl": "Kunne ikke importere scene fra den angivne URL. Det er enten misdannet eller indeholder ikke gyldige Excalidraw JSON data.",
    "resetLibrary": "Dette vil rydde hele lærredet. Er du sikker?",
    "removeItemsFromsLibrary": "Slet {{count}} vare(r) fra biblioteket?",
    "invalidEncryptionKey": "Krypteringsnøglen skal være på 22 tegn. Live-samarbejde er deaktiveret.",
    "collabOfflineWarning": "Ingen internetforbindelse tilgængelig.\nDine ændringer vil ikke blive gemt!"
  },
  "errors": {
    "unsupportedFileType": "Filtypen er ikke understøttet.",
    "imageInsertError": "Billedet kunne ikke indsættes. Prøv igen senere...",
    "fileTooBig": "Filen er for stor. Maksimal tilladt størrelse er {{maxSize}}.",
    "svgImageInsertError": "Kunne ikke indsætte SVG-billede. SVG-markup'en ser ugyldig ud.",
    "failedToFetchImage": "Dataene blev ikke hentet.",
    "invalidSVGString": "Ugyldig SVG.",
    "cannotResolveCollabServer": "Kunne ikke oprette forbindelse til samarbejdsserveren. Genindlæs siden og prøv igen.",
    "importLibraryError": "Biblioteket kunne ikke indlæses",
    "collabSaveFailed": "Kunne ikke gemme i databasen. Hvis problemerne fortsætter, bør du gemme din fil lokalt for at sikre, at du ikke mister dit arbejde.",
    "collabSaveFailed_sizeExceeded": "Kunne ikke gemme i databasen, lærredet lader til at være for stort. Du bør gemme filen lokalt for at sikre, at du ikke mister dit arbejde.",
    "imageToolNotSupported": "Billeder er deaktiveret.",
    "brave_measure_text_error": {
      "line1": "Det ser ud til, at du bruger Brave browser med indstillingen <bold>Aggressively Block Fingerprinting</bold> aktiveret.",
      "line2": "Dette kan resultere i brud på <bold>tekstelementerne</bold> i dine tegninger.",
      "line3": "Vi anbefaler kraftigt at deaktivere denne indstilling. Du kan følge <link>disse trin</link> om, hvordan du gør det.",
      "line4": "Hvis deaktivering af denne indstilling ikke løser visning af tekstelementer, åbn venligst et <issueLink>issue</issueLink> på vores GitHub, eller skriv os på <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Indlejringselementer kan ikke tilføjes til biblioteket.",
      "iframe": "IFrame elementer kan ikke tilføjes til biblioteket.",
      "image": "Understøttelse af at tilføje billeder til biblioteket kommer snart!"
    },
    "asyncPasteFailedOnRead": "Kunne ikke indsætte (kan ikke læse fra systemets udklipsholder).",
    "asyncPasteFailedOnParse": "Kunne ikke indsætte.",
    "copyToSystemClipboardFailed": "Kunne ikke kopiere til udklipsholderen."
  },
  "toolBar": {
    "selection": "&Udvalg",
    "image": "Indsæt billeder",
    "rectangle": "Rektangler",
    "diamond": "Diamanter",
    "ellipse": "Ellipser",
    "arrow": "Pile",
    "line": "Linje",
    "freedraw": "Tegn",
    "text": "Tekster",
    "library": "~Bibliotek",
    "lock": "Behold valgte værktøj aktiv efter tegning",
    "penMode": "Pen-tilstand - forhindrer berøring",
    "link": "Tilføj/ Opdater link for en valgt form",
    "eraser": "Slet",
    "frame": "Rammeværktøj",
    "magicframe": "Wireframe til kode",
    "embeddable": "Web-indlejring",
    "laser": "Lasermarkør",
    "hand": "Hånd (panorering værktøj)",
    "extraTools": "Flere værktøjer",
    "mermaidToExcalidraw": "Mermaid til Excalidraw",
    "magicSettings": "AI indstillinger"
  },
  "headings": {
    "canvasActions": "Lærred handlinger",
    "selectedShapeActions": "Valgte figurhandlinger",
    "shapes": "Former"
  },
  "hints": {
    "canvasPanning": "For at flytte lærred, hold musehjulet eller mellemrumstasten mens du trækker, eller brug håndværktøjet",
    "linearElement": "Klik for at starte flere punkter, træk for enkelt linje",
    "freeDraw": "Klik og træk, slip når du er færdig",
    "text": "Tip: du kan også tilføje tekst ved at dobbeltklikke hvor som helst med det valgte værktøj",
    "embeddable": "Klik på træk for at oprette en hjemmeside indlejret",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Kan ikke vise forhåndsvisning",
    "canvasTooBig": "Lærredet kan være for stort.",
    "canvasTooBigTip": "Tip: Prøv at flytte de fjerneste elementer lidt tættere sammen."
  },
  "errorSplash": {
    "headingMain": "Der opstod en fejl. Prøv <button>at genindlæse siden</button>.",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "<button></button> Kopiere og indsæt venligst oplysningerne nedenfor i et GitHub problem.",
    "sceneContent": "Scene indhold:"
  },
  "roomDialog": {
    "desc_intro": "Du kan invitere folk til din nuværende scene, så de kan samarbejde med dig.",
    "desc_privacy": "Bare rolig, sessionen bruger end-to-end kryptering, så uanset hvad du tegner vil det forblive privat. Ikke engang vores server vil kunne se, hvad du kommer op med.",
    "button_startSession": "Start session",
    "button_stopSession": "Stop session",
    "desc_inProgressIntro": "Live-samarbejde session er nu begyndt.",
    "desc_shareLink": "Del dette link med enhver, du ønsker at samarbejde med:",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Fejl"
  },
  "exportDialog": {
    "disk_title": "Gem til disk",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "Læs vores blog",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "element": "",
    "elements": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "title": "Statistik for nørder",
    "total": "",
    "version": "",
    "versionCopy": "Klik for at kopiere",
    "versionNotAvailable": "",
    "width": "Bredde"
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "Kopieret stilarter.",
    "copyToClipboard": "Kopieret til klippebord.",
    "copyToClipboardAsPng": "Kopieret {{exportSelection}} til klippebord som PNG\n({{exportColorScheme}})",
    "fileSaved": "Fil gemt.",
    "fileSavedToFilename": "Gemt som {filename}",
    "canvas": "canvas",
    "selection": "markering",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
